import StyleSheet from '../../../utils/helpers/styleSheet'
import ReactInputSlider from 'react-input-slider'
import {createUseStyles} from 'react-jss'

interface Props {
  xMin: number
  xMax: number
  xStep: number
  x: number
  onDragStart?: () => void
  onDragEnd: (value: number) => void
  onChange: (value: number) => void
  marker?: number
  fullWidth?: boolean
}

const sliderStyle: StyleSheet = {
  thumb: {backgroundColor: '#7ac943'},
  track: {
    borderRadius: 15,
    backgroundColor: 'white',
    border: '1px solid #d9f1e0',
  },
  active: {borderRadius: 0, backgroundColor: '#d9f1e0'},
}

const useStyles = createUseStyles({
  inputSlider: ({
    markerPosition,
    fullWidth,
  }: {
    markerPosition: number | undefined
    fullWidth: boolean | undefined
  }) => ({
    '&': {width: fullWidth ? '100%!important' : 200},

    '&:before':
      markerPosition !== undefined
        ? {
            content: '""',
            position: 'absolute',
            width: '1px',
            height: '22px',
            backgroundColor: '#3f403e',
            left: `${markerPosition}%`,
            top: 'calc(50% + -11px)',
            zIndex: -1,
          }
        : {},
  }),
})
export default function InputSlider({
  xMax,
  xMin,
  xStep,
  x,
  onDragStart,
  onDragEnd,
  onChange,
  marker,
  fullWidth,
}: Props) {
  // input slider does not return with the value on dragStart and dragEnd
  // so have to save the last values to use in those methods
  let currentValue: number | null = null

  const classes = useStyles({markerPosition: marker, fullWidth: fullWidth})
  const extraProps = {className: classes.inputSlider}

  return (
    <ReactInputSlider
      styles={sliderStyle}
      axis="x"
      xmin={xMin}
      xmax={xMax}
      xstep={xStep}
      x={x}
      onDragStart={() => onDragStart && onDragStart()}
      onDragEnd={() => {
        if (currentValue) {
          onDragEnd(currentValue)
        }
      }}
      onChange={({x}) => {
        currentValue = x

        onChange(x)
      }}
      {...extraProps}
    />
  )
}
